import { create } from '@bufbuild/protobuf'
import { type ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { getImputationPolicy } from '@ebalance/proto/bffuser/v1/imputation_policy_service-ImputationPolicyService_connectquery'
import {
  GetImputationPolicyRequestSchema,
  type GetImputationPolicyResponse,
} from '@ebalance/proto/bffuser/v1/imputation_policy_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

/**
 * GetImputationPolicy クエリフック。
 */
export function useGetImputationPolicyQuery(): UseQueryResult<
  GetImputationPolicyResponse,
  ConnectError
> {
  return useQuery(
    getImputationPolicy,
    create(GetImputationPolicyRequestSchema, {}),
  )
}
